import { gql } from "@apollo/client";

// Static quick-fill list for the substances table (English, unpaginated).
// Fetch once, filter client-side against `searchTerm`.
export const HarmfulSubstanceCatalog = gql`
    query HarmfulSubstanceCatalog {
        harmfulSubstanceCatalog {
            key
            formula
            name
            searchTerm
            dangerClass
            risks
            firstAid
        }
    }
`;
